import { Dialog, Button, Typography } from "@platform/design-system";

type CancelModalProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  confirmChange: () => void;
};

export const CancelModal: React.FC<CancelModalProps> = ({
  open,
  setOpen,
  confirmChange,
}) => {
  const onClose = (): void => setOpen(false);
  const onConfirmClick = (): void => {
    onClose();
    confirmChange();
  };

  return (
    <Dialog
      onClose={onClose}
      open={open}
      title={"Discard Changes?"}
      maxWidth="xs"
      actions={
        <>
          <Button
            data-testid="modal-cancel-button"
            onClick={onClose}
            variant="tertiary"
          >
            Cancel
          </Button>
          <Button
            data-testid="modal-confirm-button"
            variant="secondary"
            onClick={onConfirmClick}
          >
            Close and discard changes
          </Button>
        </>
      }
      sx={{ "& .MuiDialogTitle-root": { fontWeight: 500 } }}
    >
      <Typography variant="body-large">
        Changes will be discarded. Are you sure you want to close?
      </Typography>
    </Dialog>
  );
};
